import { useEffect, useRef } from "react";
import { toast } from "sonner";

let lastToast = 0;
const warn = () => {
  const now = Date.now();
  if (now - lastToast > 3000) { lastToast = now; toast.info("La copie est désactivée sur ce contenu."); }
};

/**
 * Empêche de copier, couper, coller, glisser-déposer, d'ouvrir le menu contextuel et d'imprimer le contenu.
 * La sélection reste possible (nécessaire pour surligner), sauf avec noSelect (quiz).
 * Ce n'est qu'un frein : une capture d'écran ou une photo reste possible.
 */
export default function CopyGuard({ active = true, noSelect = false, className = "", children, ...rest }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !active) return undefined;
    const block = (e) => { e.preventDefault(); if (e.type !== "dragstart" && e.type !== "contextmenu") warn(); };
    const quiet = (e) => e.preventDefault();
    const evs = [["copy", block], ["cut", block], ["paste", block], ["dragstart", quiet], ["contextmenu", quiet]];
    evs.forEach(([n, f]) => el.addEventListener(n, f));
    return () => evs.forEach(([n, f]) => el.removeEventListener(n, f));
  }, [active]);
  const cls = active ? `copy-guard no-print ${noSelect ? "select-none [-webkit-touch-callout:none]" : ""}` : "";
  return <div ref={ref} className={`${cls} ${className}`.trim()} {...rest}>{children}</div>;
}
